






































































































































































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Token, Vente, Client, Achat} from '@/models';
import storeVente from "@/stores/modules/vente";
import storeToken from "@/stores/modules/token";
import Checked from "@/components/Checked.vue";
import CrudVenteEditDialog from "@/components/Crud/Vente/EditDialog.vue";
import CrudClientEditDialog from "@/components/Crud/Client/EditDialog.vue";
import storeAchat from "@/stores/modules/achat";

@Component({
	components: {
	CrudVenteShow,
	CrudVenteEditDialog,
	Checked,
	}
})
export default class CrudVenteShow extends AbstractShowVue<Vente> {

	private editVente: Vente = null;

	@Stored(() => storeToken)
	private token: Token;

	public constructor() {
		super(storeVente);
	}

	private async venteMarkFacture(vente: Vente): Promise<void> {
		await storeVente.dispatch('putMarkPaid', vente);
		await storeVente.dispatch('get', this.value.id);
	}
}
